<template>
  <div>
    <h2>访问日志</h2>
    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="student_id" label="学生ID" width="100"></el-table-column>
      <el-table-column prop="student_name" label="用户名" width="150"></el-table-column>
      <el-table-column prop="module_name" label="访问模块"></el-table-column>
      <el-table-column prop="action" label="动作"></el-table-column>
      <el-table-column prop="visit_time" label="访问时间" width="180"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import api from '@/api'
export default {
  data() { return { tableData: [], loading: false } },
  created() { this.fetchData() },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await api.getPlatformVisits({limit:100});
        this.tableData = res || [];
      } catch (e) { console.error(e) }
      finally { this.loading = false; }
    }
  }
}
</script>